export default "__VITE_ASSET__CoHmUKF1__"